"use client";

export default function RegionSelect({
  value,
  onChange,
  options = [],
  label = "Region",
}) {
  return (
    <div className="mb-4">
      <label className="block mb-1 font-medium text-sm text-textSecondary">
        {label}
      </label>
      <select
        className="w-full border border-gray-700 rounded p-2 text-sm bg-background text-textPrimary"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">All Regions</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
